























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '../Store/FinanceiroStore'

@Component
export default class ModalItemsRecebimentoMonitor extends Vue {
  get modalItemsRecebimentoMonitor() { return this.getFinanceiroStore.modal.itemsRecebimentoMonitor }
  set modalItemsRecebimentoMonitor(value: boolean) { this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoMonitor', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itens() {
    return this.getFinanceiroStore.itensRecebimentoMonitor
  }

  formatLabel(label: string): string {
    return label.replace(/([A-Z])/g, ' $1').trim()
  }

  /**
   * A URL do arquivo chega como SAS do blob, ou seja, outro dominio. Link cross-origin ignora
   * o atributo download, entao abrimos em aba nova: a pessoa nao perde a tela e o proprio blob
   * decide entre baixar e exibir, conforme o Content-Disposition.
   */
  ehLinkDeArquivo(value: any): boolean {
    return typeof value === 'string' && /^https?:\/\//.test(value)
  }

  closeModalItemsRecebimentoMonitor() {
    this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoMonitor', value: false })
  }
}
